module.exports = __webpack_public_path__ + "img/20190523191111微信截图_20190523191427.3c766250.png";